import { BaseService } from "./base.service";
import AddInternalUser from "models/SignUp/InternalUser";
import { IUserAndAdGroup } from "models/UserAndAdGroupModel";
import { IUserByDepartmentModel } from "models/UserByDepartmentModel";
import { IMenuAccessRightModel } from "models/MenuAccessRightModel";
import { IUser, IBuyerModel } from "models/InternalUser/UserModel";
import { GuestUserModel } from "models/BidCommittee/BidCommitteeDetailModel";

class UserServiceInternal extends BaseService {
	saveUser = async (userModel: AddInternalUser): Promise<number> =>
		this.callApi<number>(`User/Signup`, "POST", undefined, userModel);

	assignRole = async (userId: number, roleId: number): Promise<undefined> =>
		this.callApi<undefined>(`User/AssignRole`, "POST", undefined, {
			userId: userId.toString(),
			roleId: roleId.toString(),
		});

	getUserAndAdGroupList = async (
		moduleId: number,
		modulePhaseId: number,
		erpDbCompanyId?: number
	): Promise<IUserAndAdGroup[]> =>
		this.callApi<IUserAndAdGroup[]>(
			`User/GetUserAndAdGroupList/${moduleId}/${modulePhaseId}`,
			"GET",
			erpDbCompanyId
				? new URLSearchParams({ erpDbCompanyId: erpDbCompanyId?.toString() })
				: undefined
		);

	getInternalUsers = async (): Promise<IUser[]> =>
		this.callApi<IUser[]>(`User/GetInternalUsers`, "GET");

	getUserListByDepartmentId = async (
		departmentId: number
	): Promise<IUserByDepartmentModel[]> =>
		this.callApi<IUserByDepartmentModel[]>(
			`User/GetUserListByDepartmentId/${departmentId}`,
			"GET"
		);

	getNomineeUsers = async (request: {
		departmentId?: number | null;
		departmentInstanceId?: number | null;
		subDepartmentId?: number | null;
	}): Promise<IUserByDepartmentModel[]> => {
		const queryParams = new URLSearchParams();
		if (request.departmentId && request.departmentId > 0) {
			queryParams.append("departmentId", request.departmentId.toString());
		}
		if (request.departmentInstanceId && request.departmentInstanceId > 0) {
			queryParams.append(
				"departmentInstanceId",
				request.departmentInstanceId.toString()
			);
		}
		if (request.subDepartmentId && request.subDepartmentId > 0) {
			queryParams.append("subDepartmentId", request.subDepartmentId.toString());
		}

		return this.callApi<IUserByDepartmentModel[]>(
			`User/GetNomineeUsers`,
			"GET",
			queryParams
		);
	};

	getUserMenuAccessRights = async (): Promise<IMenuAccessRightModel[]> =>
		this.callApi<IMenuAccessRightModel[]>(
			`User/GetUserMenuAccessRights`,
			"GET"
		);

	getConversionToUserAndAdGroupList = async (
		moduleId: number
	): Promise<IUserAndAdGroup[]> =>
		this.callApi<IUserAndAdGroup[]>(
			`User/GetConversionToUserAndAdGroupList/${moduleId}`,
			"GET"
		);

	getConversionToUserAndBidCommitteeList = async (
		moduleId: number
	): Promise<IUserAndAdGroup[]> =>
		this.callApi<IUserAndAdGroup[]>(
			`User/GetConversionToUserAndBidCommitteeList/${moduleId}`,
			"GET"
		);

	getUserListByRegionId = async (
		regionId: number
	): Promise<IUserByDepartmentModel[]> =>
		this.callApi<IUserByDepartmentModel[]>(
			`User/GetUsersByRegionId/${regionId}`,
			"GET"
		);
	getGuestUsers = async (): Promise<GuestUserModel[]> =>
		this.callApi<GuestUserModel[]>(
			"User/GetGuestUsers",
			"GET",
			undefined,
			undefined
		);
	getBidCommitteeMemberInternalUserList = async (): Promise<GuestUserModel[]> =>
		this.callApi<GuestUserModel[]>(
			"User/BidCommitteeMemberInternalUserList",
			"GET",
			undefined,
			undefined
		);

	getBuyers = async (): Promise<IBuyerModel[]> =>
		this.callApi<IBuyerModel[]>("User/GetBuyers", "GET", undefined, undefined);
}

export const UserService = new UserServiceInternal();
